/* v19: add a middle ridge to the sunset scene (runs after alpine.js) */
(function () {
  var near = document.querySelector(".scene--sunset .sunset-ridge--near");
  if (!near || document.querySelector(".sunset-ridge--mid")) return;
  var mid = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  mid.setAttribute("class", "sunset-ridge sunset-ridge--mid");
  mid.setAttribute("viewBox", "0 0 1400 320");
  mid.setAttribute("preserveAspectRatio", "none");
  mid.innerHTML = '<path d="M0 320V180l130-70 110 50 150-100 130 82 120-48 160 90 140-72 150 62 110-40 100 46V320z"/>';
  near.parentNode.insertBefore(mid, near);
})();
